import SV from 'server-vars';

/**
 * Determine if the current user is trade *only on page load* based on the nav header's values in server-vars.
 *
 * @returns {boolean}
 */
export function isTradeUserSV() {
    return SV.get('settings.isUserTypeTrade');
}

/**
 * Determine if the current user is trade based on the body tag.
 *
 * @returns {boolean}
 */
export function isTradeUserBody() {
    const els = typeof document !== 'undefined' ? document.querySelectorAll('body.is-trade') : [];
    return els.length > 0;
}

/**
 * Check the body and server-vars to see if the user has type trade.
 *
 * This should be set up to be called when listening for the logged-in event, in case the user logs in mid-session.
 *
 * @returns {boolean} Returns a true/false flag based on the user.
 */
function isTradeUser() {
    return isTradeUserSV() || isTradeUserBody();
}

export default isTradeUser;



// WEBPACK FOOTER //
// ./assets/js/global/isTradeUser.es.js